<template>
    <div class="menuView">
        <div class="menu-box" v-for="(item, index) of menuList" :key="index" :class="[currentMenu.id===item.id ? 'active' : '']" @click="changeMenu(item)">
            <div  v-if="item.key === 'base'">
            <div class="title">{{item.title}}</div>
            <div>{{item.count}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import statisticsApi from '@/api/statistics'

let bookKeyList = {
    '专题': {
        key: '',
        path: ''
    },
    '事件': {
        key: 'event',
        path: 'getBookEvent'
    },
    '人物': {
        key: 'person',
        path: 'getBookPerson'
    },
    '作品': {
        key: '',
        path: ''
    },
    '图表元数据': {
        key: 'pic',
        path: 'getBookPic'
    },
    '地理': {
        key: 'geo',
        path: 'getBookGeo'
    },
    '文献元数据': {
        key: 'base',
        path: 'getBookBase'
    },
    '机构': {
        key: 'org',
        path: 'getBookOrg'
    },
    '细颗粒度数据': {
        key: 'schema',
        path: 'getBookSchema'
    },
     '全部数据': {
        key: 'all',
        path: 'getBookDataAll'
    }
};

export default {
    data () {
        return {
            menuList: [],
            currentMenu: {
                id: 1
            }
        }
    },
    mounted () {
        // for (let i = 0; i < 8; i++) {
        //     this.menuList.push({
        //         id: i,
        //         title: '数据',
        //         count: 15945
        //     });
        // }
        this.getData();
    },
    methods: {
        changeMenu (item) {
            this.currentMenu = item;
            // this.$bus.$emit('changeBookPage', item);
            this.$parent.changeBookSelect(item);
        },
        getData () {
            let that = this;
            // that.menuList = [{
            //     id: 'all',
            //     title: '全部',
            //     count: 0
            // }];

            statisticsApi.getSubItemStatistics({
                type: 'paper',
                libraryCode: this.global.getLibraryInfos().code

            }).then(response => {
                console.log(response);
                if (response.code === 200) {
                    let count = 0;
                    let countAll = 0;
                    for (let key in response.data) {
                        that.menuList.push({
                            id: count++,
                            title: key,
                            count: response.data[key],
                            path: bookKeyList[key].path,
                            key: bookKeyList[key].key
                        });
                        countAll += response.data[key];
                    }
                    // that.menuList[0].count = countAll;
                    console.log(countAll);
                    if (that.menuList.length > 0) {
                        that.currentMenu = that.menuList[1];
                        that.$parent.changeBookSelect(that.currentMenu);
                    }
                }
            })
        }
    }
};
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";

.menuView {
    width: 100%;
    height: 80 * @uh;
    background: rgba(255, 255, 255, 0.6);
    position: relative;
    z-index: 10;
    margin-top: 100 * @uh;
    display: flex;
    justify-content: center;
    align-items: center;

    .menu-box {
        width: 130 * @uw;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 15 * @uw;
        color: #8d5e1a;
        cursor: pointer;

        .title {
            width: 100%;
            overflow: hidden;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
    }
    .active {
        font-weight: bold;
        border-bottom: 3px solid #8d5e1a;
    }
}
</style>
